import React from 'react';
import { Stack } from 'new/elements/Stack';
import { Typography } from '@mui/material';
import { ReactComponent as Star } from 'new/components/icons/star.svg';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';

const StarredProjectsEmpty = () => {
  return (
    <Stack justifyContent="center" alignItems="center" justifyItems="center" spacing="32px">
      <Star width="65" height="65" style={{ marginTop: '150px' }} />
      <Typography variant="subtitle1">Starred Projects</Typography>
      <Typography variant="body2">
        Return to a Project faster by adding it to your Starred Projects collection.
      </Typography>
    </Stack>
  );
};

StarredProjectsEmpty.screenConfig = {
  screenName: 'StarredProjectsEmpty',
  pageTitle: 'Starred Projects',
  domain: 'integrate',
  path: `${ROUTE_REDESIGN}${ROUTE_CONNECT}/projects/starred`,
};

export default StarredProjectsEmpty;
